export default __webpack_public_path__ + "static/media/accounting-light.aa5e0055.svg";